var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-desc"},[_c('div',{staticClass:"bottom-desc-title"},[_vm._v("常见付费问题")]),_vm._v(" "),_vm._l((_vm.cptList),function(item,index){return _c('desc-item',{key:index,attrs:{"item":item,"index":index + 1}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/tariff/bottom-desc/index.vue?vue&type=template&id=d70b06f6&scoped=true
// module id = null
// module chunks = 